<template>
  <div>
    <el-dialog
      v-if="visible"
      show-close
      :visible.sync="visible"
      append-to-body
      width="780px"
      :title="title"
      :close-on-click-modal="false"
      :before-close="() => $refs.editFrom.cancel()"
    >
      <EditFrom
        ref="editFrom"
        :changeOrderCode="changeOrderCode"
        :orderInspectionDocCode="orderInspectionDocCode"
        :changeOrderInspectionDocCode="changeOrderInspectionDocCode"
        @close="close"
        @reload="$emit('reload')"
      />
      <span slot="footer">
        <el-button size="small" @click="$refs.editFrom.cancel()">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button type="primary" size="small" @click="$refs.editFrom.save()">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import EditFrom from './index.vue'
export default {
  components: { EditFrom },
  props: {
    title: { type: String, default: '' },
    visible: { type: Boolean, default: false },
    changeOrderCode: String,
    orderInspectionDocCode: String,
    changeOrderInspectionDocCode: String,
  },
  methods: {
    close() {
      this.$emit('close')
      this.$emit('update:visible', false)
    },
  },
}
</script>
